import { render } from "./HelpDoc.vue?vue&type=template&id=6f11bcf7&scoped=true&ts=true"
import script from "./HelpDoc.vue?vue&type=script&lang=ts"
export * from "./HelpDoc.vue?vue&type=script&lang=ts"

import "./HelpDoc.vue?vue&type=style&index=0&id=6f11bcf7&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f11bcf7"]])

export default __exports__